/* jshint ignore:start */
// angular
//   .module("HeroPRO")
//   .controller("ProductCenterController", productCenterController)
//   .config(function($locationProvider) {
//   	  $locationProvider.html5Mode(true);
//   });

import './productCenter.scss';

/* @ngInject */
export default function productCenterController($rootScope, $scope, $sce, $window, $timeout, $document, $stateParams, $location, $q, HPConfig, raSpinnerService, productLookupService, geoStateCacheService, categoryCacheService) {
    const vm = this;

    const INITIAL_GEO_STATE = $stateParams.GeoState || 'CA';

    vm.iFrameLoaded = false;

    vm.iframeLoad = function () {
        angular.element(document.querySelectorAll('#resources')).addClass('show');
        angular.element(document.querySelectorAll('#productLookupOne')).addClass('hide');
        if (raSpinnerService.isRegistered('productLookupOne')) {
            raSpinnerService.hide('productLookupOne');
        }
        vm.iFrameLoaded = true;
    };

    vm.pageView = $stateParams.productLookupPage;

    vm.historyBack = function () {
        $window.history.back();
    };

    vm.categories = null;

    setupProductCenter();
    
    function setupProductCenter() {
        if (raSpinnerService.isRegistered('productCenterSpinner')) {
            raSpinnerService.show('productCenterSpinner');
        }

        const currentGeoState = geoStateCacheService.getGeoStates() ? geoStateCacheService.getCurrentStateObject().StateAbbreviation : INITIAL_GEO_STATE;


        // show spinner so need to have this trigger after watch is over
        $timeout(() => {
            const promise1 = productLookupService.getProductCategories(currentGeoState, null);
            const promise2 = productLookupService.getGeoStates();

            $q.all([promise1, promise2]).then((data) => {
                categoryCacheService.setCategories(data[0].data.ProductCategories);
                vm.categories = data[0].data.ProductCategories;

                geoStateCacheService.setGeoStates(data[1].data.StateGeos);

                $rootScope.$broadcast('productCenter.setupComplete');

                $timeout(() => {
                    if (raSpinnerService.isRegistered('productCenterSpinner')) {
                        raSpinnerService.hide('productCenterSpinner');
                    }
                });
            }, (reason) => {
                $window.alert(`Failed: ${reason}`);
            });
        });
    }
}
/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/productCenter/productCenterController.js